import React from "react";
import { useParams } from "react-router";
import NavBar from "../components/ui/navbar";
import Table from "../components/ui/table";
import Chart from "../components/ui/chart";
import { Box } from "@chakra-ui/react";

function Page({ data }: { data: any }) {
  let { id } = useParams();
  return (
    <>
      <NavBar data={data} selected="teams" />
      <Box w="full" h="calc(50vh - 60px)">
        <Chart
          plotData={getPlotlyData(data, id, data.dataDate)}
          title={data.teams.filter((t: any) => t.TeamId == id)[0].Name}
          yaxis="Performance %"
        />
      </Box>
      <Box w="full" h="calc(50vh)">
        <h1>Team {id} Trades</h1>
        <Table
          columnDefs={data.tradeData.cols}
          tableData={data.tradeData.items.filter(
            (trade: any) => trade.TeamId == id
          )}
        />
      </Box>
    </>
  );
}

function getPlotlyData(data: any, id: any, dataDate: string) {
  var plotly: any[] = [];
  var length = 0;
  //Team line
  data.fundPerfData
    .filter((t: any) => t.ItemId == id)
    .map((s: any) => {
      //let x = Array.from({ length: s.PercPerfs.length }, (e, i) => i);
      length = s.PercPerfs.length;
      let x = buildDates(dataDate, s.PercPerfs.length);
      plotly.push({
        x: x,
        y: s.PercPerfs, // Array.from(s.PercPerfs, (v: any) => (v / 100 + 1) * 5000000),
        type: "scatter",
        mode: "lines",
        name: s.Name,
      });
    });

  //Stock lines
  data.tradeData.items
    .filter((trade: any) => trade.TeamId == id)
    .toSorted((a: any, b: any) => (a.Stock > b.Stock ? 1 : -1))
    .map((t: any) => {
      var lineDetails = plotly.filter(
        (line: any) => line.StockId == t.StockId
      )[0];
      if (lineDetails === undefined) {
        lineDetails = createLine(data, t, length, dataDate);
        if (lineDetails) plotly.push(lineDetails);
      }
      if (lineDetails) addTradePoint(lineDetails, t.WeekNum);
    });
  return plotly;
}

function createLine(
  data: any,
  tradeDetails: any,
  length: number,
  dataDate: string
) {
  var stockPerfItem = data.stockPerfData.filter(
    (s: any) => s.ItemId == tradeDetails.StockId
  )[0];
  if (stockPerfItem !== undefined) {
    let y = getRebasedStockPerfs(stockPerfItem.PercPerfs, length);
    let x = buildDates(dataDate, y.length);
    let opacity = Array.from({ length: y.length }, (e, i) => 0);
    return {
      StockId: tradeDetails.StockId,
      x: x,
      y: y,
      type: "scatter",
      mode: "lines+markers",
      name: tradeDetails.Stock,
      marker: { opacity: opacity },
    };
  }
  return undefined;
}

function addTradePoint(lineDetails: any, weekNum: number) {
  var opacity = lineDetails.marker.opacity;
  var tradepoint = opacity.length - (weekNum - 1) * 5 - 1;
  opacity[tradepoint] = 1;
  return;
}

function getRebasedStockPerfs(perfData: number[], length: number) {
  if (perfData.length <= length) return perfData;
  var factor = perfData[length - 1] / 100 + 1;

  var rebasedData = Array.from(
    perfData.slice(0, length),
    (v) => ((v / 100 + 1) / factor - 1) * 100
  );
  return rebasedData;
}

function buildDates(baseDate: string, itemCount: number) {
  const date = new Date(baseDate);
  var day = date.getDay();
  //let x = Array.from({ length: s.PercPerfs.length }, (e, i) => i);
  var x: Date[] = [];
  for (let i = 0; i < itemCount; i++) {
    if (day === 0) {
      date.setDate(date.getDate() - 2);
      day = 5;
    }
    x.push(new Date(date));
    date.setDate(date.getDate() - 1);
    day -= 1;
  }
  return x;
}

export default Page;
